export function isLongTextLocale(locale: string): boolean {
  const longTextLocales = ['de-DE'];
  return longTextLocales.includes(locale);
}

export const getIconClass = (iconClassTag: string): string => {
  const lastIndex = iconClassTag.lastIndexOf('/');
  if (lastIndex !== -1) {
    return iconClassTag.substring(lastIndex + 1);
  }
  return iconClassTag;
};
